;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Col, Row, Container, Card } from 'reactstrap';
import QuoteIcon from './svg/QuoteIcon';
import SquaredImage from './SquaredImage';

type TestimonialTileProps = {
  quote: string;
  name: string;
  position: string;
  imagePath?: string;
  quoteColor?: string;
  noBgColor?: boolean;
};

const TestimonialTile = ({
  quote,
  name,
  position,
  imagePath,
  noBgColor = false,
  quoteColor = undefined,
}: TestimonialTileProps) => (
  // const { id, uri, title, logo } = company;
  <Card className={`testimonialCard p-md-5 ${noBgColor ? 'bg-transparent border-0' : ''}`}>
    <Container className="testimonialTile">
      <QuoteIcon className="d-lg-none mb-3 mb-lg-0" fill={quoteColor} />
      <Row>
        <Col lg={{ offset: 1, size: 4 }} className="d-flex justify-content-center  mb-5 mb-lg-0">
          <SquaredImage src={imagePath} />
        </Col>
        <Col lg={{ offset: 1, size: 6 }} className="d-flex flex-column justify-content-between">
          <QuoteIcon className="d-none d-lg-block mb-3 mb-lg-0" fill={quoteColor} />
          {quote && <p className="quote">{quote}</p>}
          <div>
            {name && <p className="mb-1 personInfo">{name}</p>}
            {position && <p className="mb-1 personInfo">{position}</p>}
          </div>
        </Col>
      </Row>
    </Container>
  </Card>
);
export default TestimonialTile;
